import { z } from 'zod/v4';
export var IntentType;
(function (IntentType) {
    IntentType["Deposit"] = "DEPOSIT";
    IntentType["Unknown"] = "UNKNOWN";
})(IntentType || (IntentType = {}));
// Unknown
const UnknownIntentSchema = z.object({ type: z.literal(IntentType.Unknown) });
export const UnknownIntent = () => ({
    type: IntentType.Unknown,
});
// Deposit
export var DiscountType;
(function (DiscountType) {
    DiscountType["Amount"] = "AMOUNT";
    DiscountType["Fraction"] = "FRACTION";
})(DiscountType || (DiscountType = {}));
const AmountDiscountSchema = z.object({
    type: z.literal(DiscountType.Amount),
    amount: z.number(),
});
export const AmountDiscount = (amount) => ({
    type: DiscountType.Amount,
    amount,
});
const FractionDiscountSchema = z.object({
    type: z.literal(DiscountType.Fraction),
    fraction: z.number(),
});
export const FractionDiscount = (fraction) => ({
    type: DiscountType.Fraction,
    fraction,
});
export const DiscountSchema = z.union([
    AmountDiscountSchema,
    FractionDiscountSchema,
]);
const DepositIntentSchema = z.object({
    type: z.literal(IntentType.Deposit),
    collectionPeriod: z.number(), // Days
    discount: DiscountSchema.nullish(),
});
export const DepositIntent = (period = 10, discount) => ({
    type: IntentType.Deposit,
    collectionPeriod: period,
    discount,
});
export const IntentSchema = z.union([UnknownIntentSchema, DepositIntentSchema]);
//# sourceMappingURL=index.js.map